import React, { useState, useEffect } from "react";
import "./packItem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {formatDate} from '../../../utils/DateUtils'
import {
    faPenToSquare,
    faCopy,
    faExternalLinkAlt,
    faImages,
    faDeleteLeft,
    faCheckCircle,
    faTimesCircle,
    faHourglassHalf,
    faPenFancy,
    faCoins,
    faFileWaveform
} from "@fortawesome/free-solid-svg-icons";
import createDOMPurify from "dompurify";
import PackForm from "./pack-form";
import { Link } from "react-router-dom";
import { PackService } from '../pack.service.js'
import { TYPE_MESSAGE } from "../../../utils/Constant";
import { useTranslation } from "react-i18next";
import MessageManager from "../../commons/message/messageManager";
import { KEY_STORAGE } from "../../../utils/Constant";
import { useLocalStorage } from "../../../hooks/useLocalStorage";

export default function PackItem(props) {
    const { data, deleteItem } = props;
    const { getItem } = useLocalStorage();
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [profileUser, setProfileUser] = useState()
    const [valueEdit, setValueEdit] = useState({});
    const { t, i18n } = useTranslation();
    const [messageManagerState, setMessageManagerState] = useState({
        show: false,
        type: TYPE_MESSAGE.INFO,
        title: "",
        messageText: "",
    });

    useEffect(() => {
       (async () => {
            const dataProfile = await getItem(KEY_STORAGE.USER_PROFILE)
            setProfileUser(dataProfile)
        })()

    }, []);


    const handleMessage = (show, title, messageText, type) => {
        setMessageManagerState({
            show: show,
            type: type,
            title: title,
            messageText: messageText,
        });
        setTimeout(() => {
            setMessageManagerState({
                show: false,
                type: TYPE_MESSAGE.INFO,
                title: "",
                messageText: "",
            });
        }, 3000);
    };

    const statusValidationLabels = {
        A: 'Aprobado',
        P: 'Pendiente',
        R: 'Rechazado',
        M: 'Modificar',
    };

    const statusValidationIcons = {
        A: faCheckCircle,
        P: faHourglassHalf,
        R: faTimesCircle,
        M: faPenFancy,
    };



    return (
        <div className="packContainer">
            <PackForm
                isEdit={true}
                value={valueEdit}
                showModal={showModalEdit}
                setShowModal={setShowModalEdit}
                onChange={(item) => { }}
            />
            <MessageManager
                show={messageManagerState.show}
                title={messageManagerState.title}
                messageText={messageManagerState.messageText}
                type={messageManagerState.type}
                onClose={() => {
                    setMessageManagerState({
                        show: false,
                        type: TYPE_MESSAGE.INFO,
                        title: "a",
                        messageText: "b",
                    });
                }}
            />

            <div className="item-section-pack-column">
                <div className="item-section-pack-column-input">
                    <div className={`item-status-multimedia${data.status_validation}`}  >
                        {/* {statusValidationLabels[data.status_validation]} */}
                        <FontAwesomeIcon
                            icon={statusValidationIcons[data.status_validation]}
                            //className="icon-pack-action"
                            className={`item-status-multimedia${data.status_validation}`}
                            onClick={() => { }}
                        />

                        {
                            (data.status_validation == 'A') &&

                            <Link to={`/history-window/${data.id}`}>
                                <FontAwesomeIcon
                                    icon={faFileWaveform}
                                    className="icon-pack-action"
                                    onClick={() => { }}
                                />
                            </Link>
                        }
                    </div>


                    <span className="item-date-pack">{formatDate(data.created)}</span>
                    <div>
                        <Link to={`/multimedia/${data.id}`}>
                            <FontAwesomeIcon
                                icon={faImages}
                                className="icon-pack-action"
                                onClick={() => { }}
                            />
                        </Link>


                        {
                            (data.status_validation !== 'A') &&
                            <FontAwesomeIcon
                                icon={faPenToSquare}
                                className="icon-pack-action"
                                onClick={() => {
                                    setValueEdit(data);
                                    setShowModalEdit(true);
                                }}
                            />}


                        {
                            (data.status_validation !== 'A') &&
                            <FontAwesomeIcon
                                icon={faDeleteLeft}
                                className="icon-pack-action"
                                onClick={async () => {
                                    if (window.confirm('¿Estás seguro de que quieres eliminar este Pack?')) {

                                        await PackService("DEL", data);
                                        deleteItem(data.id)

                                    }
                                }}
                            />
                        }
                    </div>
                </div>
            </div>
            <div className="item-section-pack-column-img">
                {/* <img src={data.front_page} /> */}



                {(data.front_page && data.front_page instanceof Blob) ? (

                    <img
                        alt="not fount"
                        className="profile-img-pack-1"
                        src={
                            URL.createObjectURL(data.front_page)

                        }
                    />



                ) : <img
                    alt="not fount"
                    className="profile-img-pack-1"
                    src={data.front_page}


                />
                }



            </div>

            <div className="item-section-pack-column">
                <span className="item-pack-title">Código de desbloqueo</span>
                <div className="item-section-pack-column-input">
                    <input value={data.unlock_code} readOnly />
                    <FontAwesomeIcon icon={faCopy}
                        className="icon-pack-action"
                        onClick={async () => {

                            await navigator.clipboard.writeText(
                                data.unlock_code
                            );

                            handleMessage(
                                true,
                                null,
                                t("Codigo de debloqueo copiado"),

                                TYPE_MESSAGE.INFO
                            );


                            // setValueEdit(data);     
                            //  setShowModalEdit(true);
                        }}
                    />
                </div>
            </div>
            <div className="item-section-pack-column">
                <span className="item-pack-title">URL del pack</span>
                <div className="item-section-pack-column-input">
                    <input value={'contenidohot.com/pack/' + data.slug} readOnly />
                    <FontAwesomeIcon icon={faExternalLinkAlt}
                        className="icon-pack-action"
                        onClick={() => {
                            window.open('https://contenidohot.com/pack' + data.slug);
                        }}
                    />
                    <FontAwesomeIcon icon={faCopy}
                        className="icon-pack-action"
                        onClick={async () => {
                            await navigator.clipboard.writeText(
                                "http://contenidohot.com/pack/" + data.slug
                            );

                            handleMessage(
                                true,
                                null,
                                t("URL del pack copiada"),

                                TYPE_MESSAGE.INFO
                            );
                        }}
                    />
                </div>
            </div>

            <div className="item-section-pack-column">
                <span className="item-pack-title">URL del pack - Facebook</span>
                <div className="item-section-pack-column-input">
                    <input value={'contenidohot-1.web.app/' + data.slug} readOnly />
                    <FontAwesomeIcon icon={faExternalLinkAlt}
                        className="icon-pack-action"
                        onClick={() => {
                            window.open('https://contenidohot-1.web.app/' + data.slug);
                        }}
                    />
                    <FontAwesomeIcon icon={faCopy}
                        className="icon-pack-action"
                        onClick={async () => {
                            await navigator.clipboard.writeText(
                                "https://contenidohot-1.web.app/" + data.slug
                            );

                            handleMessage(
                                true,
                                null,
                                t("URL del pack copiada"),

                                TYPE_MESSAGE.INFO
                            );
                        }}
                    />
                </div>
            </div>

            { profileUser && profileUser.authorized_sell && 
            <div className="item-section-pack-column">
                <div className="item-section-pack-column-input">
                    <div className="item-price-pack">
                        <div>
                            <span className="item-amount"> COP {data.price}</span>
                            <span className="item-amount-text">Precio</span>
                        </div>
                        <div>

                            <span className="item-amount">
                                <FontAwesomeIcon icon={faCoins}
                                    className="icon-pack-action-price"
                                    onClick={() => {
                                    }}
                                />

                                {data.amount}</span>
                            <span className="item-amount-text">Fichas </span>
                        </div>
                    </div>
                </div>
            </div> 
            }

            <div className="item-section-pack-column">
                <span className="item-pack-title">Descripción</span>
                {
                    <div className="item-pack-description"
                        dangerouslySetInnerHTML={{
                            __html: createDOMPurify.sanitize(data.description),
                        }}
                    />
                }
            </div>
        </div>
    );
}
